import React, {useEffect, useRef, useState} from "react";
import jQuery from 'jquery'
// import ReactMultiselectCheckboxes from "react-multiselect-checkboxes/lib/ReactMultiselectCheckboxes";
import BookCard from "../BookCard";
import genres from "../../genres.json"
import "./style.css";
import {BouncingBalls} from "react-cssfx-loading";
import api from "../../http";
import Select from 'react-select';
import {defaultFilters, initialFilters, FILTER_QUERY_KEYS} from './filters';
// import { Button, Card, Col, Container, Form, Row } from 'react-bootstrap';

window.jQuery = jQuery;

function Books(props) {
    const options = genres.genres;
    const [initial] = useState(() => {
        let saved = {};
        try {
            saved = JSON.parse(localStorage.getItem("filters")) || {};
        } catch {
            // An invalid stored selection should not prevent opening a shared link.
        }
        return initialFilters(window.location.search, saved, props.author_id);
    });
    const [screenWidth] = useState(window.innerWidth);
    const [loading, setLoading] = useState(true);
    const [, setAreMetaGenresUpdated] = useState(false);
    const defaultGenresMetaInclude = [...new Set(options.map(option => option.metaName))].join('|');
    const [selectedOptions, setSelectedOptions] = useState(() => {
        const metaNames = initial.genresMetaInclude.split('|');
        const genreCodes = initial.genresInclude.split('|');
        return options.filter(option => metaNames.includes(option.metaName) || genreCodes.includes(option.value));
    });
    const [books, setBooks] = useState([]);
    const [limit, setLimit] = useState(Number(initial.limit));
    const [yearMin, setYearMin] = useState(initial.yearMin);
    const [yearMax, setYearMax] = useState(initial.yearMax);
    const [avgRateMin, setAvgRateMin] = useState(initial.avgRateMin);
    const [avgRateMax, setAvgRateMax] = useState(initial.avgRateMax);
    const [totalGradesMin, setTotalGradesMin] = useState(initial.totalGradesMin);
    const [totalGradesMax, setTotalGradesMax] = useState(initial.totalGradesMax);
    const [showOnlySubscribedAuthorsBooks, setShowOnlySubscribedAuthorsBooks] = useState(initial.showOnlySubscribedAuthorsBooks);
    const [showOnlyBooksWithoutUserGrades, setShowOnlyBooksWithoutUserGrades] = useState(initial.showOnlyBooksWithoutUserGrades);
    const [orderBy, setOrderBy] = useState(initial.orderBy);
    const [genresMetaInclude, setGenresMetaInclude] = useState(initial.genresMetaInclude);
    const [genresInclude, setGenresInclude] = useState(initial.genresInclude);
    const [resetVersion, setResetVersion] = useState(0);

    const resetFilters = () => {
        const defaults = defaultFilters(props.author_id);
        localStorage.removeItem("filters");
        const url = new URL(window.location.href);
        FILTER_QUERY_KEYS.forEach(key => url.searchParams.delete(key));
        window.history.replaceState(window.history.state, '', url);
        setLimit(defaults.limit);
        setYearMin(defaults.yearMin);
        setYearMax(defaults.yearMax);
        setAvgRateMin(defaults.avgRateMin);
        setAvgRateMax(defaults.avgRateMax);
        setTotalGradesMin(defaults.totalGradesMin);
        setTotalGradesMax(defaults.totalGradesMax);
        setShowOnlySubscribedAuthorsBooks(false);
        setShowOnlyBooksWithoutUserGrades(false);
        setOrderBy(defaults.orderBy);
        setGenresMetaInclude(defaults.genresMetaInclude);
        setGenresInclude(defaults.genresInclude);
        setSelectedOptions([]);
        setResetVersion(version => version + 1);
    };

    // Updated handler for hierarchical genre selection
    const handleGenreChange = (selected, actionMeta) => {
        let newSelectedOptions = [...selected]; // Start with the options selected by react-select
        const { action, option, removedValue } = actionMeta;

        const metaGenresSearchText = ["Выбрать все", "Вся деловая литература", "Все любовные романы", "Вся фантастика", "Все приключение",
            "Все детективы и триллеры", "Вся литература для детей", "Вся документальная литература", "Всё про компьютеры и интернет",
            "Всё про науку и образование", "Вся драматургия", "Вся поэзия", "Вся проза", "Всё прочее"];

        const isMeta = (opt) => metaGenresSearchText.includes(opt?.label);
        const getMetaOption = (metaName) => options.find(opt => isMeta(opt) && opt.metaName === metaName);
        const getChildrenOptions = (metaName) => options.filter(opt => !isMeta(opt) && opt.metaName === metaName);

        if (action === 'select-option') {
            // If selected option is a meta-genre
            if (isMeta(option)) {
                const children = getChildrenOptions(option.metaName);
                // Add children to selection if not already there
                children.forEach(child => {
                    if (!newSelectedOptions.some(sel => sel.value === child.value)) {
                        newSelectedOptions.push(child);
                    }
                });
            } 
            // If selected option is a child genre
            else if (option?.metaName) { 
                const children = getChildrenOptions(option.metaName);
                const metaOption = getMetaOption(option.metaName);
                // Check if all children of this metaName are now selected
                const allChildrenSelected = children.every(child => 
                    newSelectedOptions.some(sel => sel.value === child.value)
                );
                // If all children selected and meta option exists, add meta option
                if (allChildrenSelected && metaOption && !newSelectedOptions.some(sel => sel.value === metaOption.value)) {
                    newSelectedOptions.push(metaOption);
                }
            }
        } else if (action === 'deselect-option' || action === 'remove-value') {
            const deselectedOption = option || removedValue;
            // If deselected option is a meta-genre
            if (isMeta(deselectedOption)) {
                const children = getChildrenOptions(deselectedOption.metaName);
                // Remove meta and all its children
                newSelectedOptions = newSelectedOptions.filter(opt => 
                    opt.metaName !== deselectedOption.metaName
                );
            } 
            // If deselected option is a child genre
            else if (deselectedOption?.metaName) { 
                const metaOption = getMetaOption(deselectedOption.metaName);
                // If the corresponding meta option was selected, deselect it
                if (metaOption && newSelectedOptions.some(sel => sel.value === metaOption.value)) {
                    newSelectedOptions = newSelectedOptions.filter(opt => opt.value !== metaOption.value);
                }
            }
        } else if (action === 'clear') {
            newSelectedOptions = [];
        }

        // Remove duplicates just in case
        const uniqueSelectedOptions = newSelectedOptions.filter((opt, index, self) =>
            index === self.findIndex((o) => o.value === opt.value)
        );

        setSelectedOptions(uniqueSelectedOptions);
    };

    // Custom function to format option labels with indentation
    const formatOptionLabel = ({ label, metaName }, { context }) => {
        const metaGenresSearchText = ["Выбрать все", "Вся деловая литература", "Все любовные романы", "Вся фантастика", "Все приключение",
            "Все детективы и триллеры", "Вся литература для детей", "Вся документальная литература", "Всё про компьютеры и интернет",
            "Всё про науку и образование", "Вся драматургия", "Вся поэзия", "Вся проза", "Всё прочее"];
        const isMeta = metaGenresSearchText.includes(label);

        if (context === 'menu') { // Apply only within the menu list
            if (isMeta) {
                // Style for meta-genres (e.g., bold)
                return <strong style={{ paddingLeft: '0px' }}>{label}</strong>;
            } else {
                // Style for specific genres (e.g., indented with a prefix)
                return <span style={{ paddingLeft: '10px' }}>↳ {label}</span>; // Added prefix and adjusted padding
            }
        }
        // Default rendering for selected value display (if controlShouldRenderValue wasn't false)
        return label; 
    };

    // Rerender instantly on change
    const fetchBooks = () => {
        setLoading(true)
        setBooks([])
        if (!props.author_id) {
            localStorage.setItem("filters", JSON.stringify({
                yearMin: yearMin,
                yearMax: yearMax,
                avgRateMin: avgRateMin,
                avgRateMax: avgRateMax,
                totalGradesMin: totalGradesMin,
                totalGradesMax: totalGradesMax,
                user_id: props.currentUser ? (props.currentUser.user_id ? props.currentUser.user_id : 0) : 0,
                showOnlySubscribedAuthorsBooks: showOnlySubscribedAuthorsBooks,
                showOnlyBooksWithoutUserGrades: showOnlyBooksWithoutUserGrades,
                orderBy: orderBy,
                genresMetaInclude: genresMetaInclude,
                genresInclude: genresInclude
            }))
        }
        return api.get('/books', {
            params: {
                limit: limit,
                books_like: props.booksLike,
                authors_like: props.authorsLike,
                author_id: props.author_id ? props.author_id : 0,
                year_min: yearMin === '' ? 0 : yearMin,
                year_max: yearMax,
                avgRateMin: avgRateMin / 2,
                avgRateMax: avgRateMax / 2,
                total_grades_min: totalGradesMin,
                total_grades_max: totalGradesMax,
                showOnlySubscribedAuthorsBooks: showOnlySubscribedAuthorsBooks,
                showOnlyBooksWithoutUserGrades: showOnlyBooksWithoutUserGrades,
                orderBy: orderBy,
                genresMetaInclude: genresMetaInclude === defaultGenresMetaInclude ? "" : genresMetaInclude,
                genresInclude: genresInclude
            }
        })
            .then((res) => {
                setLoading(false)
                setBooks(res?.data?.data)
            })
            .catch((e) => {
                // alert("Произошла ошибка", {okButtonStyle: "danger"})
                console.log(e)
            })
    }

    useEffect(() => {
        fetchBooks();
        // Fetch on mount, pagination and reset; edited filters use Confirm.
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [limit, resetVersion]);

    const firstSearchUpdate = useRef(true);
    useEffect(() => {
        if (firstSearchUpdate.current) {
            firstSearchUpdate.current = false
        } else {
            const timeOutId = setTimeout(() => fetchBooks(), 1500)
            return () => clearTimeout(timeOutId);
        }
    }, [props.booksLike, props.authorsLike])


    // This useEffect calculates filters based on selected options
    useEffect(() => {
        let metaGenresSearchText = ["Выбрать все", "Вся деловая литература", "Все любовные романы", "Вся фантастика", "Все приключение",
            "Все детективы и триллеры", "Вся литература для детей", "Вся документальная литература", "Всё про компьютеры и интернет",
            "Всё про науку и образование", "Вся драматургия", "Вся поэзия", "Вся проза", "Всё прочее"];

        let metaGenresArr = []
        let genresArr = []
        // Iterate over the array of selected option objects
        for (let i = 0; i < selectedOptions.length; i++) {
            const currentOption = selectedOptions[i];
            // Check if the label corresponds to a meta-genre
            if (metaGenresSearchText.includes(currentOption.label)) {
                // Add the metaName to metaGenresArr if not already present
                if (!metaGenresArr.includes(currentOption.metaName)) {
                     metaGenresArr.push(currentOption.metaName)
                }
            } else {
                // It's a specific genre, add its value to genresArr if not already present
                // Also check if its parent meta-genre ISN'T selected (to avoid duplicates)
                const parentMetaSelected = selectedOptions.some(opt => 
                    metaGenresSearchText.includes(opt.label) && opt.metaName === currentOption.metaName
                );
                if (!parentMetaSelected && !genresArr.includes(currentOption.value)) {
                     genresArr.push(currentOption.value)
                }
            }
        }
        setGenresMetaInclude(metaGenresArr.join('|'))
        setGenresInclude(genresArr.join('|'))
    }, [selectedOptions, options])

    let metaGenresSearchText = ["Выбрать все", "Вся деловая литература", "Все любовные романы", "Вся фантастика", "Все приключение",
        "Все детективы и триллеры", "Вся литература для детей", "Вся документальная литература", "Всё про компьютеры и интернет",
        "Всё про науку и образование", "Вся драматургия", "Вся поэзия", "Вся проза", "Всё прочее"];

    const removeGenre = (e, isMeta, optionToRemove) => {
        let currentGenres;
        let updatedSelectedOptions;

        if (isMeta) {
            // Remove all options belonging to this meta-genre
            updatedSelectedOptions = selectedOptions.filter(opt => opt.metaName !== optionToRemove.metaName);
            // Update the filter strings (redundant due to useEffect, but kept for clarity maybe?)
            currentGenres = genresMetaInclude.split('|').filter(g => g !== optionToRemove.metaName);
            setGenresMetaInclude(currentGenres.join('|'))
        } else {
            // Remove the specific genre option object
            updatedSelectedOptions = selectedOptions.filter(opt => opt.value !== optionToRemove.value);
             // Update the filter strings (redundant due to useEffect)
            currentGenres = genresInclude.split('|').filter(g => g !== optionToRemove.value);
            setGenresInclude(currentGenres.join('|'))
        }
        setSelectedOptions(updatedSelectedOptions);
    }
    
    const showMoreBooks = () => {
        if (limit >= 750) {
            document.getElementById("show_more_btn").style.background = "#dc3545"
            document.getElementById("show_more_btn").innerHTML = 'Достигнуто максимальное кол-во книг на странице'
        } else {
            setLimit(limit + 60)
        }
    }

    // Refined function to display genre pills hierarchically
    const getGenresPill = () => {
        if (selectedOptions.length === 0) return null; // No pills if nothing selected

        const metaGenresSearchText = ["Выбрать все", "Вся деловая литература", "Все любовные романы", "Вся фантастика", "Все приключение",
        "Все детективы и триллеры", "Вся литература для детей", "Вся документальная литература", "Всё про компьютеры и интернет",
        "Всё про науку и образование", "Вся драматургия", "Вся поэзия", "Вся проза", "Всё прочее"];
        const isMeta = (opt) => metaGenresSearchText.includes(opt?.label);

        const pills = [];
        const processedMetaNames = new Set(); // Keep track of meta-genres already handled

        // Prioritize showing meta-genre pills
        selectedOptions.forEach(option => {
            if (isMeta(option) && !processedMetaNames.has(option.metaName)) {
                pills.push(
                    <span key={option.value} onClick={(e) => removeGenre(e, true, option)}
                          className="genre-pill">{option.label}</span>
                );
                processedMetaNames.add(option.metaName);
            }
        });

        // Show individual genre pills only if their meta-parent isn't selected
        selectedOptions.forEach(option => {
            if (!isMeta(option) && !processedMetaNames.has(option.metaName)) {
                 pills.push(
                    <span key={option.value} onClick={(e) => removeGenre(e, false, option)}
                          className="genre-pill">{option.label}</span>
                );
            }
        });
        
        // Limit displayed pills
        if (pills.length > 10) {
             return <span className="genre-pill-info">Слишком много жанров выбрано...</span>;
        }

        return pills;
    }

    return (
        <div>
            <div className="filters pb-2 border-bottom">
                <div className="container-fluid p-4">
                    <div className="row">
                        <div className="col-12 col-sm-4" id="yearFilter">
                            <div className="col-12 text-center">
                                <h5>Год</h5>
                            </div>
                            <div className="input-group justify-content-center">
                                <div className="input-group-prepend">
                                    <span className="input-group-text" id="basic-addon1">От</span>
                                </div>
                                <input className={"form-control"} type="number" value={yearMin}
                                       onChange={e => setYearMin(e.target.value)} placeholder={"Минимальный год"}/>
                            </div>
                            <div className="input-group justify-content-center">
                                <div className="input-group-prepend">
                                    <span className="input-group-text" id="basic-addon1">До</span>
                                </div>
                                <input className={"form-control"} type="number" value={yearMax}
                                       onChange={e => setYearMax(e.target.value)} placeholder={"Максимальный год"}/>
                            </div>
                        </div>

                        <div className="col-12 col-sm-4" id="ratingFilter">
                            <div className="col-12 text-center">
                                <h5>Средняя оценка</h5>
                            </div>
                            <div className="input-group justify-content-center">
                                <div className="input-group-prepend">
                                    <span className="input-group-text" id="basic-addon1">От</span>
                                </div>
                                <input className={"form-control"} type="number" value={avgRateMin}
                                       onChange={e => setAvgRateMin(e.target.value)}
                                       placeholder={"Минимальная оценка"}/>
                            </div>
                            <div className="input-group justify-content-center">
                                <div className="input-group-prepend">
                                    <span className="input-group-text" id="basic-addon1">До</span>
                                </div>
                                <input className={"form-control"} type="number" value={avgRateMax}
                                       onChange={e => setAvgRateMax(e.target.value)}
                                       placeholder={"Максимальная оценка"}/>
                            </div>
                        </div>

                        <div className="col-12 col-sm-4" id="gradesFilters">
                            <div className="col-12 text-center">
                                <h5>Всего голосов</h5>
                            </div>
                            <div className="input-group justify-content-center">
                                <div className="input-group-prepend">
                                    <span className="input-group-text">От</span>
                                </div>
                                <input className={"form-control"} type="number" value={totalGradesMin}
                                       onChange={e => setTotalGradesMin(e.target.value)}
                                       placeholder={"Минимальное кол-во голосов"}/>
                            </div>
                            <div className="input-group justify-content-center">
                                <div className="input-group-prepend">
                                    <span className="input-group-text">До</span>
                                </div>
                                <input className={"form-control"} type="number" value={totalGradesMax}
                                       onChange={e => setTotalGradesMax(e.target.value)}
                                       placeholder={"Максимальное кол-во голосов"}/>
                            </div>
                        </div>
                    </div>
                </div>
                <div>
                    <div className="d-flex justify-content-center">
                        <div className="mb-3 genres-list">
                            {getGenresPill()}
                        </div>
                    </div>
                    <div>
                        <div onMouseMove={() => setAreMetaGenresUpdated(false)} onClick={() => setAreMetaGenresUpdated(false)}
                             className="input-group d-flex justify-content-center">
                            <div className="input-group-prepend">
                                <label className="input-group-text" htmlFor="genresSelect">Жанры: </label>
                            </div>
                            <Select
                                id="genresSelect"
                                isMulti
                                options={options}
                                value={selectedOptions}
                                onChange={handleGenreChange}
                                placeholder="Сортировка по жанрам"
                                className="react-select-container"
                                classNamePrefix="react-select"
                                closeMenuOnSelect={false}
                                hideSelectedOptions={false}
                                controlShouldRenderValue={false}
                                formatOptionLabel={formatOptionLabel}
                            />
                        </div>
                        <div className="input-group d-flex justify-content-center mt-2" id="sort_order">
                            <div className="input-group-prepend">
                                <label className="input-group-text" htmlFor="inputGroupSelect01">Сортировать по </label>
                            </div>
                            <select className="form-select" id="inputGroupSelect01" value={orderBy}
                                    onChange={e => setOrderBy(e.target.value)}>
                                <option value="time_desc">Времени &#8595;</option>
                                <option value="time_asc">Времени &#8593;</option>
                                <option value="total_desc">Количеству оценок &#8595;</option>
                                <option value="total_asc">Количеству оценок &#8593;</option>
                                <option value="average_desc">Средней оценке &#8595;</option>
                                <option value="average_asc">Средней оценке &#8593;</option>
                            </select>
                        </div>
                    </div>
                    <div>

                    </div>
                    <div className="settings">
                        {
                            !props.author_id ?
                                <React.Fragment>
                                    <div className="form-check form-switch d-flex justify-content-center mt-3">
                                        <input className="form-check-input" type="checkbox" value=""
                                               onChange={() => setShowOnlySubscribedAuthorsBooks(!showOnlySubscribedAuthorsBooks)}
                                               id="showOnlySubscribedAuthorsBooks" disabled={!props.currentUser}
                                               checked={showOnlySubscribedAuthorsBooks}/>
                                        <label className="form-check-label ms-2"
                                               htmlFor="showOnlySubscribedAuthorsBooks">
                                            Показывать только книги тех авторов на которых вы подписаны
                                        </label>
                                    </div>
                                    {!props.currentUser ?
                                        <p className="small text-center">&nbsp;*Данная функция доступна только
                                            зарегестрированным пользователям</p> : null}
                                </React.Fragment>
                                : null
                        }
                        <React.Fragment>
                            <div className="form-check form-switch d-flex justify-content-center mt-3 w-100">
                                <input className="form-check-input" type="checkbox" value=""
                                       onChange={() => setShowOnlyBooksWithoutUserGrades(!showOnlyBooksWithoutUserGrades)}
                                       id="showOnlyBooksWithoutUserGrades" disabled={!props.currentUser}
                                       checked={showOnlyBooksWithoutUserGrades}/>
                                <label className="form-check-label ms-2" htmlFor="showOnlyBooksWithoutUserGrades">
                                    Скрыть оценённые книги
                                    <span className="badge rounded-pill text-bg-primary ms-2">Новое</span>
                                </label>
                            </div>
                            {!props.currentUser ? <p className="small text-center">&nbsp;*Данная функция доступна только
                                зарегестрированным пользователям</p> : null}
                        </React.Fragment>
                    </div>

                    <div className="d-flex justify-content-center align-items-center mt-5">
                        <button className="border-0 btn btn-success submitButton"
                                onClick={() => fetchBooks()}>Подтвердить
                        </button>
                        {
                            props.author_id ? null : <button onClick={resetFilters}
                                                             className={"btn border-0 ms-4 btn-outline-secondary resetFilters"}>Сбросить
                                фильтры </button>
                        }
                    </div>


                </div>
            </div>

            <div className="App">
                {!loading
                    ? books.length !== 0
                        ? (
                            books.map((book) => (
                                <BookCard key={book.bookid || book.id} {...book} currentUser={props.currentUser} screenWidth={screenWidth}/>)))
                        : <p className="books-not-found-text text-center">По вашему запросу не было найдено книг :(</p>

                    :
                    <div className="align-items-center justify-content-center d-flex mt-5">
                        <BouncingBalls color={'orange'} width={'58px'} height={'20px'}/>
                    </div>
                }
            </div>
            <div className="d-flex justify-content-center show_more">
                <button onClick={showMoreBooks} className={"btn btn-info btn-sm"} id="show_more_btn">Показать больше
                </button>
            </div>
        </div>
    );
}

export default Books;
